// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"c63ab874","453":"4cb40e99","681":"c282c0fe","861":"9898da4e"}[chunkId] + ".chunk.js";
};